// bust.$emit('animateBottombar')
import _ from 'lodash'

export default {
  state: {
    // isAnimating: false,

    animationQueue: [],
    animationOrder: [
      'Background',
      'BottomBar',
      'SubBottomBar',
      'Slides',
      'ReferenceSlider',
      'Tags',
      'MasterplanTags',
      'LivingOptionTags',
      'LivingOptionSubsections',
      'LivingOptionProperties',
      'SideBar'
    ],

    newAnimationQueue: [],

    // place
    animateBackground: '',
    animateBottomBarNavItems: [],
    animateSubBottomBarNavItems: [],
    animateTags: [],
    animateSlides: [],
    animateSidebar: {},

    // live
    animateLivingOptionSlides: [],
    animateLivingOptionTags: [],
    animateLivingOptionSubsections: [],
    animateLivingOptionProperties: [],
    animatePropertySlides: [],
    animatePropertyModal: {}
  },

  getters: {
    sortedAnimationQueue (state) {
      let sorted = []
      state.animationOrder.forEach(component => {
        if (state.newAnimationQueue.includes(component)) {
          sorted.push(component)
        }
      })
      return sorted
    },
  },

  mutations: {
    addAnimationToQueue (state, component) {
      let queue = state.newAnimationQueue
      queue.push(component)
      state.newAnimationQueue = _.uniq(queue)
    },

    advanceAnimationQueue (state, lastAnimatedComponent) {
      let componentIndex = state.newAnimationQueue.indexOf(lastAnimatedComponent)
      state.newAnimationQueue.splice(componentIndex, 1)
    },

    clearAnimationQueue (state) {
      state.newAnimationQueue = []
    }
  }
}